import * as React from "react";

import "./inplace-modal-service.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {keyed1}    from "@Common/react/keyed";
import {UseState}  from "@Common/react/use-state";

export const InplaceModalService = ({title, initShow=undefined, persistentRender=undefined, xdQaName=undefined, next, rootNext}) => cs(
    ["state", (_, next) => UseState({initValue: initShow && {params: initShow}, next})],
    ["exportedModal", ({state}, next) => next({
        show: (params) => state.onChange({params})
    })],
    ({exportedModal}, next) => fragments(
        next(),
        persistentRender?.(exportedModal),
    ),
    ({state}, next) => keyed1({key: !!state.value, next}),
    ({state, exportedModal}) => state.value ? (
        <div className="inplace-modal-service-5na">
            <div {...{
                className: "header",

                ...xdQaName && {
                    "xd-qa-type": "label",
                    "xd-qa-name": xdQaName + " Title",
                },
            }}>
                {title}
            </div>
            <div className="content">
                {next({
                    ...state.value,
                    close: () => state.onChange(null),
                })}
            </div>
        </div>
    ) : (
        rootNext(exportedModal)
    )
);
